<div
  class="bg-surface-950/50 pointer-events-none absolute size-full"
  [class]="{
    'backdrop-blur-sm': blur(),
  }"
></div>
